define((require) => {
    "use strict";

    var Marionette = require("marionette"),
        template   = require("editor/ui/experience/editor/LocaleSelectorControl.tpl");

    return Marionette.ItemView.extend({

        template: template,

        className: "locale-selector",

        templateHelpers: function() {
            return {
                locales: this.options.locales,
                firstVariant: this.options.firstVariant,
                addVariant: this.options.addVariant
            };
        },

        events: {
            "click .variant-action": function(event) {
                this._triggerHandler(event.currentTarget.getAttribute("data-locale"));
            }
        },

        _triggerHandler: function(localeString) {
            this.options.selectHandler(localeString);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/LocaleSelectorControl.js